export const PRO_PLAYERS = {
  sacy: { name: 'Sacy', image: '/images/players/sacy.webp' },
  coldzera: { name: 'coldzera', image: '/images/players/coldzera.webp' },
  brtt: { name: 'brTT', image: '/images/players/brtt.webp' },
  gaules: { name: 'Gaules', image: '/images/players/gaules.webp' },
  rakin: { name: 'Rakin', image: '/images/players/rakin.webp' },
  arkane: { name: 'Arkane', image: '/images/players/arkane.webp' },
  lestripez: { name: 'Lestripez', image: '/images/players/lestripez.webp' },
  suja: { name: 'Suja', image: '/images/players/suja.webp' },
  vett: { name: 'Vett', image: '/images/players/vett.webp' },
} as const;

export type ProPlayerId = keyof typeof PRO_PLAYERS;

export interface ProPlayer {
  name: string;
  image: string;
}
